<template>
  <div>
    <a-drawer
      :title="title"
      width="65%"
      placement="right"
      :visible="visible"
      @close="onClose"
    >
      <!-- <h3 class="text-overflow m-0 text-muted">{{title}}</h3> -->

      <a-drawer
        title=""
        width="500"
        :closable="false"
        @close="onChildrenDrawerClose"
        :visible="childrenDrawer"
      >
        <div v-if="childrenDrawerType == 'customize_list'">
          <h6 class="heading-small text-muted mb-4">Customize List</h6>
          <div class="list-group list-group-item">
            <div class="row">
              <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
              <div class="col-md-6">
                <a-checkbox
                  class="float-right"
                  @change="onCheckAllField"
                  :checked="
                    this.checkedFields.length == this.customizeList.length
                  "
                />
              </div>
            </div>
          </div>

          <draggable
            :list="customizeList"
            :disabled="!enabled"
            class="list-group"
            @start="dragging = true"
            @end="dragging = false"
          >
            <div
              class="list-group-item"
              v-for="element in customizeList"
              :key="element"
            >
              <div class="row">
                <div class="col-md-6">{{ element }}</div>
                <div class="col-md-6">
                  <a-checkbox
                    class="float-right"
                    @change="onCheckField(element)"
                    :checked="checkedFields.includes(element)"
                  />
                </div>
              </div>
            </div>
          </draggable>

          <div
            class="float-right"
            style="position: absolute; bottom: 20px; right: 20px"
          >
            <button
              class="btn btn-primary float-right"
              @click.prevent="updateTableColumns"
            >
              Update List
            </button>
          </div>
        </div>

        <div v-if="childrenDrawerType == 'document_filter'">
          <h6 class="heading-small text-muted mb-4">Filter Documents</h6>
          <ul class="list-group list-group-flush" style="width: 100%">
            <li
              class="list-group-item"
              style="font-size: 14px; height: 55px; background-color: #f7f7f7"
            >
              <div class="row">
                <div class="col-md-6">AVAILABLE DOCUMENTS</div>
                <!-- @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)" -->
                <div class="col-md-6"><a-checkbox class="float-right" /></div>
              </div>
            </li>

            <li
              class="list-group-item"
              style="font-size: 14px"
              v-for="document in availableDocuments"
              v-bind:key="document"
            >
              <div class="row">
                <div class="col-md-6">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ document }}
                </div>
                <div class="col-md-6">
                  <!-- @change="onCheckField(field)" :checked="fields.includes(field)" -->
                  <a-checkbox class="float-right" />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="childrenDrawerType == 'print'">
          <h6 class="heading-small text-muted mb-4">Print Options</h6>
          <div>
            <!-- v-model="filterStatus" -->
            <base-radio name="0" class="mb-3" value="O" v-model="printType">
              Print Detailed
            </base-radio>
            <base-radio name="1" class="mb-3" value="1" v-model="printType">
              Print Extended
            </base-radio>
          </div>
          <div
            style="
              position: absolute;
              bottom: 0px;
              right: 0px;
              width: -webkit-fill-available;
              background-color: #f2f2f2;
              padding: 10px;
            "
          >
            <button type="button" class="btn btn-primary float-right">
              Print
            </button>
          </div>
        </div>
      </a-drawer>

      <div class="col-md-12" style="width: inherit">
        <a-tabs defaultActiveKey="1" type="card" @change="tabChange">
          <a-tab-pane tab="Details" key="1">
            <br />
            <a-spin :spinning="spinning">
              <div
                class="row"
                style="overflow-y: scroll; height: 80vh; overflow-x: hidden"
              >
                <div class="col-md-3" style="text-align: center">
                  <!-- <div class="image-div"> -->
                  <a-upload
                    listType="picture-card"
                    :fileList="fileList"
                    class="avatar-uploader image-div"
                    disabled
                  />
                  <!-- </div> -->
                </div>
                <div class="col-md-9">
                  <h1 style="margin-bottom: 0px">{{ product.name }}</h1>
                  <!-- <small>Product Code: {{product.id}} | {{product.short_name}}</small> -->
                  <br /><br />
                  <b><label v-if="product.site_retail_price">Site Retail Price:</label></b> {{ product.site_retail_price }}
                  <br />
                  <b><label>Master Retail Price:</label></b> {{ product.retail_price }}
                  <br />
                  <b><label>Landed Cost:</label></b> {{ product.landed_cost }}

                  <hr />
                  <b><label>Stock No:</label></b> {{ product.stock_no }}
                  <br />
                  <b><label>Barcode:</label></b> {{ product.barcode }}
                  <br />
                  <b><label>Reference Code:</label></b>
                  {{ product.reference_code }}

                  <hr />
                  <b><label>Supplier:</label></b> {{ product.supplier }}
                  <br />
                  <b><label>Brand:</label></b> {{ product.brand }}
                  <br />
                  <b><label>Category:</label></b> {{ product.division }} /
                  {{ product.department }} / {{ product.section }} /
                  {{ product.class }}
                  <br />
                  <b><label>Product Group:</label></b>
                  {{ product.product_group_name }}
                  <br/>
                  <b><label>Product Grade Level:</label></b>
                  {{ product.product_grade_level}}
                  <br />
                  <br />
                  <!-- effectivity date -->
                  <div class="row">
                    <div class="col-md-6" >
                      <h2 style="margin-bottom: 0px">
                        Effectivity Date
                      </h2>
                    </div>
                    <div class="col-md-12">
                      <a-table
                        :columns="productGradeColumns"
                        :dataSource="productGradeData"
                        :pagination="false"
                        :scroll="{ y: 150 }"
                      >
                      </a-table>
                    </div>
                  </div>
                  <br/>

                  <!-- end of effectivity date -->
                  <div class="row">
                    <div class="col-md-6">
                      <h2
                        v-if="product.product_type == 'M'"
                        style="margin-bottom: 0px"
                      >
                        Matrix Variants
                      </h2>
                      <h2 v-else style="margin-bottom: 0px">Packaging</h2>
                    </div>
                    <div
                      v-if="packagingData != null && packagingData.length > 0"
                      class="col-md-6"
                    >
                      <button
                        class="btn btn-sm btn-primary float-right"
                        @click.prevent="showChildrenProducts(product.id)"
                      >
                        Show Details
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <br />
                      <a-table
                        v-if="product.product_type == 'M'"
                        :columns="matrixColumns"
                        :dataSource="packagingData"
                        bordered
                        :pagination="pagination"
                      />
                      <a-table
                        v-else
                        :columns="packagingColumns"
                        :dataSource="packagingData"
                        bordered
                        :pagination="pagination"
                      >
                        <!-- <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                                    <small>
                                    Reference Code: {{record.reference_code}} <br>  
                                    Stock No: {{record.stock_no}} <br>  
                                    </small>
                                  </p> -->
                      <template slot="description" slot-scope="text, record">
                          <a-tooltip :title="showIconTooltip(record.product_type)" placement="left">
                            <img class="product-icons" :src="iconSourcePath(record.product_type)" alt="" />
                          </a-tooltip>
                            {{ record.name }}
                      </template>

                      </a-table>
                    </div>
                  </div>

                  <br /><br />
                  <h2 style="margin-bottom: 0px">Alternate Barcodes</h2>
                  <br />
                  <a-table
                    :columns="alternateBarcodeColumns"
                    :dataSource="alternateBarcodeData"
                    :pagination="pagination"
                    bordered
                  ></a-table>
                </div>
              </div>
            </a-spin>
          </a-tab-pane>
          <a-tab-pane tab="Stock Activities" key="2">
            <!-- @valueUpdated="updateSettings" -->
            <div style="overflow-y: scroll; height: 80vh; overflow-x: hidden">
              <a-spin :spinning="spinning">
                <dynamic-form
                  :formSettings="formSettings"
                  :convertedJson="convertedJson"
                  @valueUpdated="updateSettings"
                  :key="componentKey"
                ></dynamic-form>
                <div class="row" style="padding: 0px">
                  <div class="col-md-12">
                    <button
                      class="btn btn-sm btn-primary float-right"
                      style="width: 15%"
                      @click.prevent="filterStockActivity"
                    >
                      Apply Filters
                    </button>
                    <button
                      class="btn btn-sm float-right"
                      style="
                        background-color: #394a5d;
                        color: white;
                        width: 15%;
                        margin-right: 2%;
                      "
                      @click="clearStockActivityFilter"
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <hr />

                <div class="row">
                  <div class="col-md-6">
                    <h3>Results</h3>
                  </div>
                  <div class="col-md-6">
                    <!-- <span class="fa fa-sync-alt float-right mr-2 mt-2"></span> -->
                    <base-dropdown
                      class="nav-link float-right mr-2"
                      position="right"
                    >
                      <div class="media align-items-center" slot="title">
                        <h3
                          class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                        ></h3>
                      </div>
                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('print')"
                        >
                          <i class="fa fa-print"></i><span>Print</span>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('customize_list')"
                        >
                          <i class="fa fa-list-ul"></i
                          ><span>Customize List</span>
                        </div>
                      </template>
                    </base-dropdown>
                  </div>
                </div>

                <div class="card shadow">
                  <div class="table-responsive">
                    <a-table
                      :columns="stockcardColumns"
                      :dataSource="data"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      :key="componentKey"
                      bordered
                    >
                    </a-table>
                  </div>
                </div>

                <br /><br />

                <div class="row">
                  <div class="col-md-12">
                    <h3>Summary</h3>
                  </div>
                  <div class="col-md-12">
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel
                        :header="currentSideHeader"
                        key="1"
                        disabled
                      >
                        <div class="row">
                          <div class="col-md-12">
                            <b><label>On-Hand Quantity: </label></b>
                            {{
                              this.stockCardSummary.onhand_current_site.toFixed(
                                2
                              )
                            }}<br /><br />
                          </div>
                          <div class="col-md-6">
                            <b><label>Total Outgoing: </label></b>
                            {{
                              this.stockCardSummary.outgoing_current_site.toFixed(
                                2
                              )
                            }}
                            <br /><br />
                          </div>
                          <div class="col-md-6">
                            <b><label>Total Released: </label></b>
                            {{
                              this.stockCardSummary.outgoing_current_site.toFixed(
                                2
                              )
                            }}
                            <br /><br />
                          </div>
                          <div class="col-md-6">
                            <b><label>Total Incoming: </label></b>
                            {{
                              this.stockCardSummary.sum_of_current_site.toFixed(
                                2
                              )
                            }}
                            <br />
                          </div>
                          <div class="col-md-6">
                            <b><label>Total Received: </label></b>
                            {{
                              this.stockCardSummary.sum_of_current_site_rec.toFixed(
                                2
                              )
                            }}
                            <br />
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                  </div>

                  <div class="col-md-12">
                    <br /><br />
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel header="All Sites" key="1" disabled>
                        <b><label>On-Hand Quantity: </label></b>
                        {{ this.stockCardSummary.onhand_all_site.toFixed(2) }}
                        <br /><br />
                        <b><label>Total Outgoing: </label></b>
                        {{ this.stockCardSummary.outgoing_all_site.toFixed(2) }}
                        <br /><br />
                        <b><label>Total Incoming: </label></b>
                        {{ this.stockCardSummary.sum_of_all_site.toFixed(2) }}
                        <br />
                      </a-collapse-panel>
                    </a-collapse>
                  </div>
                </div>
              </a-spin>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Quantity Breakdown" key="3">
            <div style="height: 80vh; overflow-x: hidden">
                <br />
                <div class="row">
                  <template>
                    <div class="col-md-10">
                      <a-cascader v-model="inputLocationQB" :options="locationOptions" placeholder="All Locations" style="width: 100%" changeOnSelect />

                      <!-- <a-select ref="SelectQuantityBreakDown"
                        showSearch
                        optionFilterProp="children"
                        v-model="selectedSitesQB"
                        :loading="spinning"
                        mode="multiple"
                        style="width: 100%"
                        placeholder="Select Sites"
                        @change="handleSelectSitesQuantityBreakdown"
                      >
                        <a-select-option v-for="site in sites" :key="site.id" :value="site.id">
                          {{ site.name}}
                        </a-select-option>
                      </a-select> -->
                    </div>
                    <div class="col-md-2">
                        <button
                          class="btn btn-sm btn-primary float-right"
                          style="width: 100%"
                          :loading="spinning"
                          @click.prevent="filterQuantityBreakdown"
                        >
                        Apply Filters
                        </button>
                    </div>
                  </template>
                </div>
              <a-spin :spinning="spinning">
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <h3>Regular Quantity Breakdown</h3>
                  </div>
                  <div class="col-md-6">
                    <base-dropdown
                      class="nav-link float-right mr-2"
                      position="right"
                    >
                      <div class="media align-items-center" slot="title">
                        <h3
                          class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                        ></h3>
                      </div>
                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('export')"
                        >
                          <i class="fa fa-download"></i><span>Export</span>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="
                            showChildrenDrawer('customize_list', 'regular')
                          "
                        >
                          <i class="fa fa-list-ul"></i
                          ><span>Customize List</span>
                        </div>
                      </template>
                    </base-dropdown>
                  </div>
                </div>

                <div class="card shadow">
                  <VueTabulator
                    ref="regular"
                    v-model="total_per_site_data"
                    :options="total_per_site_options"
                  />
                </div>

                <br /><br />

                <div class="row">
                  <div class="col-md-6">
                    <h3>Packing Quantity Breakdown</h3>
                  </div>
                  <div class="col-md-6">
                    <base-dropdown
                      class="nav-link float-right mr-2"
                      position="right"
                    >
                      <div class="media align-items-center" slot="title">
                        <h3
                          class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                        ></h3>
                      </div>
                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('export')"
                        >
                          <i class="fa fa-download"></i><span>Export</span>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="
                            showChildrenDrawer('customize_list', 'packing')
                          "
                        >
                          <i class="fa fa-list-ul"></i
                          ><span>Customize List</span>
                        </div>
                      </template>
                    </base-dropdown>
                  </div>
                </div>

                <div class="card shadow">
                  <VueTabulator
                    ref="packing"
                    v-model="total_per_site_packing_data"
                    :options="total_per_site_packing_options"
                  />
                </div>

                <br /><br />

                <div class="row">
                  <div class="col-md-6">
                    <h3>Lot Code Breakdown</h3>
                  </div>
                </div>

                <div class="card shadow">
                  <VueTabulator
                    ref="lotcode"
                    v-model="lotcode_data"
                    :options="lotcode_options"
                  />
                </div>
              </a-spin>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Histories" key="4">
            <br /><br />
            <div style="overflow-y: scroll; height: 80vh; overflow-x: hidden">
              <a-spin :spinning="spinning">
                <div
                  class="col-md-6 no-gutter"
                  style="margin-left: 0px; padding-left: 9px"
                >
                  <base-input label="View History" style="margin: 0px">
                    <a-select
                      style="width: 96%"
                      placeholder="Please select"
                      optionFilterProp="children"
                      v-model="historyType"
                    >
                      <a-select-option value="1">Price History</a-select-option>
                      <a-select-option value="2">Cost History</a-select-option>
                      <a-select-option value="3"
                        >Commission History</a-select-option
                      >
                    </a-select>
                  </base-input>
                </div>
                <!-- @valueUpdated="updateSettings" :key="componentKey" -->

                <div class="col-md-6 no-gutter" style="margin-left: 0px; margin-top: 20px; padding-left: 9px">
                  <base-input label="Site">
                    <a-select v-model="site_id" showSearch placeholder="Select Site" optionFilterProp="children" style="width: 96%" 
                      :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                      <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id" >{{ option.name }}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
                
                <dynamic-form
                  :formSettings="formSettings2"
                  :scroll="scroll"
                  :convertedJson="convertedJson2"
                  :parameters="JSON.stringify(dynamicFormParamater)"
                  :key="formKey"
                  @valueUpdated="updateHistoryFilter"
                ></dynamic-form>
                <div class="row" style="padding: 0px">
                  <div class="col-md-12">
                    <button
                      class="btn btn-sm btn-primary float-right"
                      style="width: 15%"
                      @click.prevent="filterHistory"
                    >
                      Apply Filters
                    </button>
                    <button
                      class="btn btn-sm float-right"
                      style="
                        background-color: #394a5d;
                        color: white;
                        width: 15%;
                        margin-right: 2%;
                      "
                      @click.prevent="clearFilterHistory"
                    >
                      Clear
                    </button>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6">
                    <h3>{{ historyHeader }}</h3>
                  </div>
                  <div class="col-md-6">
                    <!-- <span class="fa fa-sync-alt float-right mr-2 mt-2"></span> -->
                    <base-dropdown
                      class="nav-link float-right mr-2"
                      position="right"
                    >
                      <div class="media align-items-center" slot="title">
                        <h3
                          class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                        ></h3>
                      </div>
                      <template>
                        <div class="dropdown-header noti-title">
                          <h6 class="text-overflow m-0">ACTIONS</h6>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('export')"
                        >
                          <i class="fa fa-download"></i><span>Export</span>
                        </div>
                        <div
                          class="dropdown-item"
                          @click.prevent="showChildrenDrawer('customize_list')"
                        >
                          <i class="fa fa-list-ul"></i
                          ><span>Customize List</span>
                        </div>
                      </template>
                    </base-dropdown>
                    <!-- <button class="btn btn-default btn-sm float-right" @click.prevent="refreshTable">Apply Filter</button> -->
                  </div>
                </div>

                <div class="card shadow">
                  <a-table
                    :columns="historyColumns"
                    :dataSource="historyData"
                    :scroll="scroll"
                    :loading="loading"
                    :rowKey="(record) => record.id"
                    :pagination="pagination"
                    :key="historyTable"
                    bordered
                  >
                  </a-table>
                </div>

                <!-- CHANGE VALUES -->
                <br /><br />
                <h2>About</h2>
                <b><label>Created By:</label></b>
                {{ this.product.created_by }} | {{ this.product.created_at }}
                <br />
                <b><label>Updated By:</label></b>
                {{ this.product.updated_by }} | {{ this.product.updated_at }}

                <hr />
                <b><label>Last Arrival:</label></b> Oct 11, 2019
                <br />
                <b><label>Last Expected Arrival:</label></b> Oct 11, 2019

                <div class="d-flex justify-content-center mt-4">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    @click="showAdvancedInfoDiv"
                  >
                    Detailed Histories {{ showAdvancedInfo ? "↟" : "↡" }}
                  </button>
                </div>

                <div v-if="showAdvancedInfo">
                  <div class="row">
                    <div class="col-md-6">
                      <h3>Detailed Product Histories</h3>
                    </div>
                    <div class="col-md-6">
                      <base-dropdown
                        class="nav-link float-right mr-2"
                        position="right"
                      >
                        <div class="media align-items-center" slot="title">
                          <h3
                            class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                          ></h3>
                        </div>
                        <template>
                          <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                          </div>
                          <div
                            class="dropdown-item"
                            @click.prevent="download('product')"
                          >
                            <i class="fa fa-download"></i><span>Export</span>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div class="card shadow">
                    <a-table
                      :columns="advancedHistoryColumns"
                      :dataSource="advancedHistoryData"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                  <br />
                  <br />
                  <div class="row">
                    <div class="col-md-6">
                      <h3>Detailed Product Combo Price Histories</h3>
                    </div>
                    <div class="col-md-6">
                      <base-dropdown
                        class="nav-link float-right mr-2"
                        position="right"
                      >
                        <div class="media align-items-center" slot="title">
                          <h3
                            class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                          ></h3>
                        </div>
                        <template>
                          <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                          </div>
                          <div
                            class="dropdown-item"
                            @click.prevent="download('combo_price')"
                          >
                            <i class="fa fa-download"></i><span>Export</span>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div class="card shadow">
                    <a-table
                      :columns="comboPriceHistoryColumns"
                      :dataSource="comboPriceHistoryData"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                  <br />
                  <br />
                  <div class="row">
                    <div class="col-md-6">
                      <h3>Detailed Product Combo Group Histories</h3>
                    </div>
                    <div class="col-md-6">
                      <base-dropdown
                        class="nav-link float-right mr-2"
                        position="right"
                      >
                        <div class="media align-items-center" slot="title">
                          <h3
                            class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                          ></h3>
                        </div>
                        <template>
                          <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                          </div>
                          <div
                            class="dropdown-item"
                            @click.prevent="download('combo_group')"
                          >
                            <i class="fa fa-download"></i><span>Export</span>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div class="card shadow">
                    <a-table
                      :columns="comboGroupHistoryColumns"
                      :dataSource="comboGroupHistoryData"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                  <br />
                  <br />
                  <div class="row">
                    <div class="col-md-6">
                      <h3>Detailed Product Combo Value Histories</h3>
                    </div>
                    <div class="col-md-6">
                      <base-dropdown
                        class="nav-link float-right mr-2"
                        position="right"
                      >
                        <div class="media align-items-center" slot="title">
                          <h3
                            class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                          ></h3>
                        </div>
                        <template>
                          <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                          </div>
                          <div
                            class="dropdown-item"
                            @click.prevent="download('combo_value')"
                          >
                            <i class="fa fa-download"></i><span>Export</span>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div class="card shadow">
                    <a-table
                      :columns="comboValueHistoryColumns"
                      :dataSource="comboValueHistoryData"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                  <br />
                  <br />
                  <div class="row">
                    <div class="col-md-6">
                      <h3>Detailed Product Transaction Type Price Histories</h3>
                    </div>
                    <div class="col-md-6">
                      <base-dropdown
                        class="nav-link float-right mr-2"
                        position="right"
                      >
                        <div class="media align-items-center" slot="title">
                          <h3
                            class="fa fa-ellipsis-v float-right ml-2 btn-sm"
                          ></h3>
                        </div>
                        <template>
                          <div class="dropdown-header noti-title">
                            <h6 class="text-overflow m-0">ACTIONS</h6>
                          </div>
                          <div
                            class="dropdown-item"
                            @click.prevent="download('combo_price')"
                          >
                            <i class="fa fa-download"></i><span>Export</span>
                          </div>
                        </template>
                      </base-dropdown>
                    </div>
                  </div>
                  <div class="card shadow">
                    <a-table
                      :columns="transactionTypePriceHistoryColumns"
                      :dataSource="transactionTypePriceHistoryData"
                      :scroll="scroll"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                  <br />
                  <br />
                  <h3>Product Mass Update Logs</h3>
                  <div class="card shadow">
                    <a-table
                      :columns="productMassUpdateLogColumns"
                      :dataSource="productMassUpdateLogData"
                      :loading="loading"
                      :rowKey="(record) => record.id"
                      :pagination="pagination"
                      bordered
                    >
                    </a-table>
                  </div>
                </div>

                <br /><br /><br />
              </a-spin>
            </div>
          </a-tab-pane>
          <a-tab-pane
            v-if="product.product_type == 'S'"
            tab="Serial Movement"
            key="5"
          >
            <div style="height: 80vh; overflow-x: hidden">
              <a-spin :spinning="spinning">
                <div class="row">
                  <div class="col-auto">
                    <h6 class="heading-small text-muted pt-2">Document Date</h6>
                  </div>
                  <div class="col">
                    <a-range-picker
                      suffixIcon=" "
                      @change="onDateFilter"
                      v-model="serial_movement_date_filter"
                    />
                  </div>
                </div>
                <hr />
                <div class="card shadow">
                  <VueTabulator
                    v-if="serial_movement_data.length > 0"
                    ref="regular"
                    v-model="serial_movement_data"
                    :options="serial_movement_option"
                  />
                  <a-empty v-else />
                </div>
              </a-spin>
            </div>
          </a-tab-pane>
          <a-tab-pane
            v-if="product.product_type == 'S'"
            tab="Serial Inventory"
            key="6"
          >
            <div style="height: 80vh; overflow-x: hidden">
              <a-spin :spinning="spinning">
                <div class="row">
                  <div class="col-auto">
                    <h6 class="heading-small text-muted pt-2">Document Type</h6>
                  </div>
                  <div class="col">
                    <a-select
                      style="width: 100%"
                      @change="onDocumentTypeFilter"
                    >
                      <a-select-option
                        v-for="option in documentTypeOptions"
                        v-bind:key="option.key"
                      >
                        {{ option.value }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
                <hr />
                <div class="card shadow">
                  <a-table
                    :columns="serial_inventory_columns"
                    :dataSource="serial_inventory_data"
                    :rowKey="(record) => record.id"
                    :pagination="serialPagination"
                    @change="handleSerialTableChange"
                  >
                  </a-table>
                </div>
              </a-spin>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>

      <!-- <div class="fixed-bottom">
            <button type="button" class="btn btn-primary float-right ml-2" style="width: 10%">Edit Product</button>
            <button type="button" class="btn btn-default float-right" style="width: 10%">Back</button> 
        </div> -->
    </a-drawer>
  </div>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage.js";
import draggable from "vuedraggable";
import { mapState, mapActions } from "vuex";
import DynamicForm from "../DynamicForm.vue";
var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;
import moment from "moment";
import axios from "axios";
var component_x;

const advanced_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];
const combo_price_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Reference Code", dataIndex: "reference_code", key: "reference_code" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];
const transaction_type_price_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Reference Code", dataIndex: "ref_code", key: "reference_code" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];
const combo_group_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Reference Name", dataIndex: "name", key: "name" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];
const combo_value_histories_column = [
  { title: "Action", dataIndex: "action", key: "action" },
  { title: "Reference Name", dataIndex: "name", key: "name" },
  { title: "Field Name", dataIndex: "field_name", key: "field_name" },
  { title: "From", dataIndex: "old_value", key: "old_value" },
  { title: "To", dataIndex: "new_value", key: "new_value" },
  { title: "Created By/Updated By", dataIndex: "updated_by", key: "updated_by" },
  // { title: "Updated At", dataIndex: "updated_at", key: "updated_at" },
  { title: "Created At/Updated At", dataIndex: "formatted_updated_at", key: "updated_at" },
];

const packaging_columns = [
  { title: "Description", dataIndex: "name", key: "name", scopedSlots: { customRender: "description"} },
  { title: "Barcode", dataIndex: "barcode", key: "barcode" },
  { title: "Unit Code", dataIndex: "unit_code", key: "unit_code" },
  { title: "Content", dataIndex: "content_quantity", key: "content_quantity" },
];

const matrix_columns = [
  { title: "Description", dataIndex: "name", key: "name" },
  { title: "Style", dataIndex: "design_name", key: "design_name" },
  { title: "Color", dataIndex: "color_name", key: "color_name" },
  { title: "Size", dataIndex: "size_name", key: "size_name" },
  { title: "Barcode", dataIndex: "barcode", key: "barcode" },
  { title: "Unit Code", dataIndex: "unit_code", key: "unit_code" },
  { title: "Content", dataIndex: "content_quantity", key: "content_quantity" },
];

const alternate_barcode_columns = [
  { title: "Barcode", dataIndex: "barcode", key: "barcode" },
  { title: "Status", dataIndex: "status", key: "status" },
];

const stockcard_columns = [
  {
    title: "Reference No",
    dataIndex: "reference_no",
    key: "reference_no",
    fixed: "left",
    width: 200,
  },
  { title: "Post Date", dataIndex: "post_date", key: "post_date", width: 200 },
  {
    title: "Document Date",
    dataIndex: "DOCUMENT_DATE",
    key: "DOCUMENT_DATE",
    width: 200,
  },
  {
    title: "Origin Ref No",
    dataIndex: "origin_reference_no",
    key: "origin_reference_no",
    width: 200,
  },
  { title: "Party", dataIndex: "party", key: "party", width: 200 },
  {
    title: "Total In",
    dataIndex: "InvIN",
    key: "InvIN",
    width: 200,
    align: "right",
  },
  {
    title: "Total Out",
    dataIndex: "InvOUT",
    key: "InvOUT",
    width: 200,
    align: "right",
  },
  {
    title: "Balance",
    dataIndex: "RunBal",
    key: "RunBal",
    width: 200,
    align: "right",
  },
  { title: "Cost", dataIndex: "cost", key: "cost", width: 200, align: "right" },
  {
    title: "Document Price",
    dataIndex: "document_price",
    key: "document_price",
    width: 200,
    align: "right",
  },
  {
    title: "Subtotal",
    dataIndex: "subtotal",
    key: "subtotal",
    width: 200,
    align: "right",
  },
  { title: "Remark", dataIndex: "remark", key: "remark", width: 200 },
];

const cost_history_columns = [
  //   { title: 'Line', dataIndex: 'line_no', key: 'line_no', fixed: 'left', width: 200},
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
    width: 200,
    fixed: "left",
  },
  {
    title: "Update Date",
    dataIndex: "formatted_updated_at",
    key: "updated_at",
    fixed: "left",
    width: 200,
  },
  {
    title: "Original Cost",
    children: [
      {
        title: "Previous",
        dataIndex: "old_original_cost",
        key: "previous_original_cost",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_original_cost",
        key: "current_original_cost",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Ordering Cost",
    children: [
      {
        title: "Previous",
        dataIndex: "old_ordering_cost",
        key: "previous_ordering_cost",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_ordering_cost",
        key: "current_ordering_cost",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Landed Cost",
    children: [
      {
        title: "Previous",
        dataIndex: "old_landed_cost",
        key: "previous_landed_cost",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_landed_cost",
        key: "current_landed_cost",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Update Method",
    dataIndex: "triggered_via",
    key: "updated_method",
    width: 200,
  },
  { title: "Remarks", dataIndex: "remark", key: "remarks", width: 200 },
];

const price_history_columns = [
  //   { title: 'Line', dataIndex: 'line_no', key: 'line_no', fixed: 'left', width: 150},
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
    width: 200,
    fixed: "left",
  },
  {
    title: "Update Date",
    dataIndex: "formatted_updated_at",
    key: "updated_at",
    fixed: "left",
    width: 200,
  },
  {
    title: "Retail Price",
    children: [
      {
        title: "Previous",
        dataIndex: "old_retail_price",
        key: "previous_retail_price",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_retail_price",
        key: "current_retail_price",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Wholesale Price",
    children: [
      {
        title: "Previous",
        dataIndex: "old_wholesale_price",
        key: "previous_wholesale_price",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_wholesale_price",
        key: "current_wholesale_price",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Least Price",
    children: [
      {
        title: "Previous",
        dataIndex: "old_least_price",
        key: "previous_least_price",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_least_price",
        key: "current_least_price",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Special Price",
    children: [
      {
        title: "Previous",
        dataIndex: "old_special_price",
        key: "previous_special_price",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_special_price",
        key: "current_special_price",
        width: 100,
        align: "right",
      },
    ],
  },
    {
    title: "Grade Level",
    children: [
      {
        title: "Previous",
        dataIndex: "old_grade_level",
        key: "previous_grade_level",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_grade_level",
        key: "current_grade_level",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Update Method",
    dataIndex: "triggered_via",
    key: "updated_method",
    width: 200,
  },
  { title: "Remarks", dataIndex: "remark", key: "remarks", width: 200 },
];

const comission_history_columns = [
  //   { title: 'Line', dataIndex: 'line_no', key: 'line_no', fixed: 'left', width: 150},
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
    width: 200,
    fixed: "left",
  },
  {
    title: "Update Date",
    dataIndex: "formatted_updated_at",
    key: "updated_at",
    fixed: "left",
    width: 200,
  },
  {
    title: "Salesman Commission",
    children: [
      {
        title: "Previous",
        dataIndex: "old_product_commission",
        key: "previous_product_commission",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_product_commission",
        key: "current_product_commissione",
        width: 100,
        align: "right",
      },
    ],
  },
  {
    title: "Supplier Commission",
    children: [
      {
        title: "Previous",
        dataIndex: "old_supplier_commission",
        key: "previous_supplier_commission",
        width: 100,
        align: "right",
      },
      {
        title: "Current",
        dataIndex: "new_supplier_commission",
        key: "current_supplier_commission",
        width: 100,
        align: "right",
      },
    ],
  },
  { title: "Remarks", dataIndex: "remark", key: "remarks", width: 200 },
];

const productMassUpdateLogColumns = [
  {
    title: "Field Name",
    dataIndex: "field_name",
    key: "field_name",
  },
  {
    title: "From",
    dataIndex: "old_value",
    key: "old_value",
  },
  {
    title: "To",
    dataIndex: "new_value",
    key: "new_value",
  },
  {
    title: "Message",
    dataIndex: "status_message",
    key: "status_message",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
];

const serial_inventory_columns = [
  {
    title: "Serial",
    width: 200,
    dataIndex: "SERIAL_NO",
    key: "SERIAL_NO"
  },
  {
    title: "Update Date",
    width: 200,
    dataIndex: "UPDATED_AT",
    key: "UPDATED_AT"
  },
  {
    title: "Last Movement",
    width: 200,
    dataIndex: "LAST_DOC",
    key: "LAST_DOC"
  },
  {
    title: "Status",
    width: 200,
    dataIndex: "STATUS",
    key: "STATUS"
  }
];

const productGradeColumns = [
  {
    title: "Level",
    dataIndex: "level",
    scopedSlots: {
      customRender: "level",
    },
  },
  {
    title: "Effectivity Date",
    dataIndex: "effectivity_date",
    scopedSlots: {
      customRender: "effectivity_date",
    },
  },
];
const productGradeData = []; // product group array

export default {
  props: {
    icon_code:{
      type: String,
      default: function(){
        return 'SUP'
      }
    }
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "parameters",
      "profileId",
      "serverType",
      "publicUrl",
    ]),
  },
  components: {
    DynamicForm,
    draggable,
  },
  mounted: async function () {
    // console.log(this)
    // document.getElementsByClassName('ant-drawer-wrapper-body')[0].style["overflow"] = "hidden";
    // alert(this.$attrs.product)
    this.spinning = true;
    this.default_site_id = secureStorage.getItem("defaultSiteId");
    // let sites = await HTTPRequest.getRequest(this.endPoint + "/sites/get_valid_sites?mode=all",null );
    // if(sites != null){
    //   this.sites = sites;
    //   this.sites.unshift({id: -1, name: 'ALL SITES', code: 'all'});
    // }
    
    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view'  , null)

    let site = await HTTPRequest.getRequest(
      this.endPoint + "/sites/" + this.default_site_id,
      null
    );
    if (site != undefined) {
      this.default_site_type = site.site_type;
    }
    let additional_product_params = "";
    if (this.default_site_type == "branch") {
      additional_product_params = "?site_id=" + this.default_site_id;
    }

    let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?add_master=1", null);
    this.siteOptions = sites;

    var product_id = this.$attrs.product;
    this.product = await HTTPRequest.getRequest(
      this.endPoint +
        "products/" +
        product_id +
        "/stock_card_details" +
        additional_product_params,
      null,
      null
    );
    this.alternateBarcodeData = this.product.alternate_barcodes;
    if (this.product.packaging != null) {
      this.product.packaging.forEach((element) => {
        Object.assign(element, {
          key: this.packagingCount,
        });
        this.packagingData.push(element);
        this.packagingCount = this.packagingCount + 1;
      });
    }

     // product group mounted
    this.productGradeData = [];
    var product_grade_data = await HTTPRequest.getRequest(
      this.endPoint +
        "product_grades?product_id=" +
        product_id,
      null
    );

    if (product_grade_data.total) {
      product_grade_data.data.forEach((element) => {
        this.productGradeData.push({
          key: this.productGradeCount,
          effectivity_date: moment(element.effectivity_date).format(
            "MMMM DD, YYYY"
          ),
          level: element.level,
        });

        this.productGradeCount = this.productGradeCount + 1;
      });
    }
    // end product group mounted

    // this.packagingData = this.product.packaging
    this.title = _.toUpper(
      "STOCK CARD: " + this.product.name + " | " + this.product.stock_no
    );
    this.visible = this.$attrs.visible;
    this.fileList = this.product.images_url
    this.$nextTick(function () {
      //for fullscreen drawer
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
    this.lotcode_options.ajaxURL = this.endPoint + "inventories?show_lotcode=true&site_id=" + this.default_site_id + "&product_id=" + product_id + "&site_location_id=0"
    this.lotcode_options.ajaxConfig = {headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" }}

    this.total_per_site_options.ajaxURL = this.endPoint + "products/" + this.product.id + "/get_qty_breakdown?mode=regular"
    this.total_per_site_packing_options.ajaxURL = this.endPoint + "products/" + this.product.id + "/get_qty_breakdown?mode=packing"

    this.total_per_site_options.ajaxConfig = {headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" }}
    this.total_per_site_packing_options.ajaxConfig = {headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" }}

    this.spinning = false;

    // document.getElementsByClassName('ant-drawer-wrapper-body')[0].style["overflow"] = "hidden";
  },
  
  data: function () {
    return {
      detailProductHistoryDate: [moment().startOf('day'), moment().endOf('day')],
      massUpdateLogsDate: [moment().startOf('day'), moment().endOf('day')],
      spinMessage: "Loading...",
      //arvin
      tableURL: '',
      tableLogsURL: '',
      tableCSS: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      tableCSSLog: {
        table: {
          tableClass: 'table table-sm table-striped table-bordered table-hovered',
          loadingClass: 'loading'
        },
        pagination: {
          infoClass: 'pull-right',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary btn-sm',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      fields: [
        {name: "field_name", title: "Field Name"},
        {name: "old_value", title: "From"},
        {name: "new_value", title: "To"},
        {name: "updated_by", title: "Updated By"},
        {name: "updated_at", title: "Updated At"}
      ],
      fieldLogs: [
        {name: "field_name", title: "Field Name"},
        {name: "old_value", title: "From"},
        {name: "new_value", title: "To"},
        {name: "status_message", title: "Message"},
        {name: "action", title: "Action"}
      ],
      httpOptions: {
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
        }
      },
      //arvin
      default_site_id: "",
      default_site_type: "ho",
      total_per_site_data: [],
      total_per_site_options: {
        layout: "fitDataStretch",
        columnHeaderVertAlign: "bottom",
        dataTree: true,
        dataTreeChildField: "sublocation",
        pagination: "remote",
        paginationSize: 10,
        paginationDataSent:{
            "page": "page",
            "size": "per_page"
        },
        ajaxResponse:function(url, params, response){
            var res = {data: response.total_per_site, last_page: response.last_page}
            return res
        },
        columns: [
          { title: "Site/Sublocation Name", field: "name" },
          { title: "On-Hand Qty", field: "on_hand_qty", align: "right" },
          { title: "Incoming Qty", field: "incoming_qty", align: "right" },
          { title: "Outgoing Qty", field: "outgoing_qty", align: "right" },
          {
            title: "Incoming (Breakdown)",
            columns: [
              { title: "PO", field: "incoming_po", align: "right" },
              { title: "STR & STI", field: "incoming_str_sti", align: "right" },
              { title: "SLI", field: "incoming_sli", align: "right" },
            ],
          },
          {
            title: "POS Sales (TSI)",
            field: "pos_sales_quantity",
            align: "right",
          },
          {
            title: "POS Return (TSR)",
            field: "pos_returns_quantity",
            align: "right",
          },
        ],
      },
      total_per_site_packing_data: [],
      total_per_site_packing_options: {
        layout: "fitDataStretch",
        columnHeaderVertAlign: "bottom",
        dataTree: true,
        dataTreeChildField: "sublocation",
        pagination: "remote",
        paginationSize: 10,
        paginationDataSent:{
            "page": "page",
            "size": "per_page"
        },
        ajaxResponse:function(url, params, response){
            var res = {data: response.total_per_site_packing, last_page: response.last_page}
            return res
        },
        columns: [
          { title: "Site/Sublocation Name", field: "name" },
          {
            title: "On-Hand",
            columns: [
              {
                title: "Complete Unit",
                field: "onhand_complete",
                align: "right",
              },
              { title: "Spare Unit", field: "onhand_spare", align: "right" },
            ],
          },
          {
            title: "Incoming",
            columns: [
              {
                title: "Complete Unit",
                field: "incoming_complete",
                align: "right",
              },
              { title: "Spare Unit", field: "incoming_spare", align: "right" },
            ],
          },
          {
            title: "Outgoing",
            columns: [
              {
                title: "Complete Unit",
                field: "outgoing_complete",
                align: "right",
              },
              { title: "Spare Unit", field: "outgoing_spare", align: "right" },
            ],
          },
        ],
      },
      lotcode_data: [],
      lotcode_options: {
        layout: "fitColumns",
        layoutColumnsOnNewData:true,
        columnHeaderVertAlign: "bottom",
        pagination: "remote",
        paginationSize: 10,
        paginationDataSent:{
            "page": "page",
            "size": "per_page"
        } ,
        columns: [
          { title: "Lot Code", field: "lotcode", widthGrow: 3 },
          { title: "Expiry", field: "expired_at", align: "right", widthGrow: 1.5, formatter:function(cell, formatterParams, onRendered){
            return moment(new Date(cell.getValue())).format("MMMM DD, YYYY");
          }},
          { title: "Quantity", field: "onhand_quantity", align: "right", width: 150},
          ],
          initialSort:[
            {column:"expired_at", dir:"asc"}, //sort by this first
        ]
      },
      serial_movement_date_filter: [
        moment(new Date()).subtract("1", "days"),
        moment(new Date()),
      ],
      searchDateFrom: moment(new Date())
        .subtract("1", "days")
        .format("YYYY-MM-DD"),
      searchDateTo: moment(new Date()).format("YYYY-MM-DD"),
      serial_movement_data: [],
      serial_movement_option: {
        layout: "fitDataStretch",
        columnHeaderVertAlign: "bottom",
        columns: [
          { title: "Document#", field: "DOC" },
          { title: "Serial ", field: "SERIAL_NO" },
          { title: "In", field: "INV_IN" },
          { title: "Out", field: "INV_OUT" },
          { title: "Document Date", field: "DOCUMENT_DATE" },
          { title: "Status", field: "STATUS" },
          { title: "Remarks", field: "REMARKS" },
        ],
      },

      serial_inventory_data: [],
      serialPagination: {
        pageSize: 10,
        current: 1
      },
      serial_inventory_columns,
      packagingData: [],
      packagingCount: 1,
      alternateBarcodeData: [],
      showAdvancedInfo: false,
      fileList: [],
      spinning: false,
      historyTable: 0,
      activeKey: "1",
      scroll: {},
      scroll2: {},
      checkedFields: [],
      dragging: false,
      enabled: true,
      activeTab: 1,
      printType: 0,
      visible: false,
      childrenDrawer: false,
      childrenDrawerType: null,
      historyType: "1",
      historyHeader: "Price History",
      dynamicFormParamater: {},
      windowWidth: null,
      product: [],
      convertedJson: null,
      convertedJson2: null,
      stockcardColumns: stockcard_columns,
      historyColumns: price_history_columns,
      packagingColumns: packaging_columns,
      matrixColumns: matrix_columns,
      alternateBarcodeColumns: alternate_barcode_columns,
      advancedHistoryColumns: advanced_histories_column,
      comboPriceHistoryColumns: combo_price_histories_column,
      comboGroupHistoryColumns: combo_group_histories_column,
      comboValueHistoryColumns: combo_value_histories_column,
      transactionTypePriceHistoryColumns: transaction_type_price_histories_column,
      productMassUpdateLogColumns,
      productMassUpdateLogData: [],
      advancedHistoryData: null,
      comboPriceHistoryData: null,
      comboGroupHistoryData: null,
      comboValueHistoryData: null,
      transactionTypePriceHistoryData: null,
      stockCardDocuments: [],
      data: [],
      historyData: [],
      loading: false,
      pagination: false,
      title: null,
      componentKey: 0,
      formKey: 0,
      currentSite: {},
      formSettings: {},
      formSettings2: {},
      customizeList: [],
      availableFields: [
        "Reference No",
        "Post Date",
        "Document Date",
        "Origin Ref No",
        "Party",
        "Qty",
        "Total In ",
        "Total Out",
        "Balance",
        "Cost",
        "Document Price",
        "Subtotal",
        "Remark",
      ],
      availableDocuments: [
        "Concession Returns",
        "Concession Sales",
        "General Receive",
        "General Release",
        "Physical Count",
        "Purchase Return",
        "Receiving Report",
        "Transfer In",
        "Transfer Out",
      ],
      quantityBreakdownFilter: "",
      regularQuantityBreakdown: [
        "Site/Sublocation Name",
        "On-Hand Qty",
        "Incoming Qty",
        "Outgoing Qty",
        "PO",
        "STR & STI",
        "SLI",
        "POS Sales (TSI)",
        "POS Return (TSR)",
      ],
      packingQuantityBreakdown: [
        "Site/Sublocation Name",
        "On-Hand",
        "Incoming",
        "Outgoing",
      ],
      checkedRegularQuantityBreakdown: [],
      checkedPackingQuantityBreakdown: [],
      availableFields3: ["Wholesale Price", "Least Price", "Special Price"],
      availableFields4: ["Original Cost", "Ordering Cost"],
      availableFields5: ["Supplier Commission"],
      stockCardSummary: {
        sum_of_current_site: 0,
        sum_of_current_site_rec: 0,
        sum_of_all_site: 0,
        outgoing_all_site: 0,
        outgoing_current_site: 0,
        onhand_current_site: 0,
        onhand_all_site: 0,
      },
      currentSideHeader: "Current Site ",
      documentTypeOptions: [],
      documentTypeIdFilter: null,
      // product group data
      productGradeCount: 1,
      productGradeData,
      productGradeColumns,
      productLevelCount: 0,

      product_grade: {
        key: null,
        level: 0,
        effectivity_date: null,
        status: "A",
      },
      fetching: false,
      site_id: -1,
      siteOptions: [],
      // end product group data
      // sites: [],
      // selectedSitesQB: [],
      inputLocationQB: null,
      locationOptions: []

    };
  },
  watch: {
    historyType: async function () {
      this.dynamicFormParamater.historyType = this.historyType;
      this.formKey++;
      var site_id = this.formSettings2.site_id;
      var historyData;
      this.spinning = true;
      switch (this.historyType) {
        case "1":
          this.historyHeader = "Price History";
          this.historyColumns = price_history_columns;
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_price_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          this.scroll = { x: 200 * 8, y: 300 };
          break;
        case "2":
          this.historyHeader = "Cost History";
          this.historyColumns = cost_history_columns;
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_cost_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          this.scroll = { x: 200 * 7, y: 300 };
          break;
        case "3":
          this.historyHeader = "Commission History";
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_commission_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          this.historyColumns = comission_history_columns;
          this.scroll = { x: 200 * 5, y: 300 };
          break;
      }
      this.spinning = false;
      this.historyTable++;
    },
  },
  methods: {
    moment,

    ...mapActions(["updateCurrentProfile", "updateParameters"]),
    showChildrenProducts(id) {
      this.$router.push("/children_products/" + id);
    },
    onDateFilter(date, dateString) {
      this.searchDateFrom = dateString[0];
      this.searchDateTo = dateString[1];
      this.tabChange("5");
    },
    onDocumentTypeFilter(value) {
      this.documentTypeIdFilter = value;
      this.tabChange("6");
    },
    showIconTooltip(product_type){
      var productType = "";
      switch(product_type){
        case 'P':
          productType = "Package";
          break;
        case 'K':
          productType = "Kit Item";
          break;
        case 'V':
          productType = "Virtual Kit";
          break;
        default:
          break;
      }
      return productType;
    },
     iconSourcePath(product_type){
      var productType = "";
      switch(product_type){
        case 'P':
          productType = require('../../assets/icons/'+ this.icon_code + '/packaged.png')
          break;
        case 'K':
          productType = require('../../assets/icons/'+ this.icon_code + '/kit.png')
          break;
        case 'V':
          productType = require('../../assets/icons/'+ this.icon_code + '/virtual_kit.png')
          break;
        default:
          break;
      }
      return productType;
    },
    async showAdvancedInfoDiv() {
      this.showAdvancedInfo = !this.showAdvancedInfo;
      if (this.showAdvancedInfo == true) {
        var advancedHistoryData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_update_histories?product_id=" +
            this.product.id,
          null,
          null
        );
        this.advancedHistoryData = advancedHistoryData;

        var productMassUpdateLogData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_mass_update_logs?product_id=" +
            this.product.id,
          null,
          null
        );

        this.productMassUpdateLogData = productMassUpdateLogData;

        var comboPriceHistoryData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_combo_price_update_histories?product_id=" +
            this.product.id,
          null,
          null
        );
        this.comboPriceHistoryData = comboPriceHistoryData;

        var comboGroupHistoryData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_combo_group_update_histories?product_id=" +
            this.product.id,
          null,
          null
        );
        this.comboGroupHistoryData = comboGroupHistoryData;

        var comboValueHistoryData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_combo_value_update_histories?product_id=" +
            this.product.id,
          null,
          null
        );
        this.comboValueHistoryData = comboValueHistoryData;

        var transactionTypePriceHistoryData = await HTTPRequest.getRequest(
          this.endPoint +
            "product_transaction_type_price_update_histories?product_id=" +
            this.product.id,
          null,
          null
        );
        this.transactionTypePriceHistoryData = transactionTypePriceHistoryData;
      }
    },
    async handleSearch(value) {
      this.fetching = true;
      let sites = await HTTPRequest.getRequest(this.endPoint + "/sites/get_valid_sites?add_master=1&name=" + value, null, null);
      this.siteOptions = sites;
      this.fetching = false;
    },
    getWindowWidth() {
      //for fullscreen drawer
      this.windowWidth = window.innerWidth;
    },
    async filterStockActivity() {
      var site_id = this.formSettings.site_id;
      var start_date = this.formSettings.document_date[0].format("YYYY-MM-DD");
      var end_date = this.formSettings.document_date[1].format("YYYY-MM-DD");
      var party_name = this.formSettings.party_name;
      var sort_name = this.formSettings.sort_name;
      var sort_by = this.formSettings.sort_by;
      this.spinning = true;
      var stockActivityData = await HTTPRequest.getRequest(
        this.endPoint +
          "products/" +
          this.product.id +
          "/get_documents_for_stock_card?site_id=" +
          site_id +
          "&start_date=" +
          start_date +
          "&end_date=" +
          end_date +
          "&party_name=" +
          party_name 
          + "&sort_name=" + sort_name
          + "&sort_by=" + sort_by,
        null,
        null
      );
      this.data = stockActivityData.document_list;
      console.log("stock: ",stockActivityData.document_list)
      var summaryDetails = await HTTPRequest.getRequest(
        this.endPoint +
          "products/" +
          this.product.id +
          "/get_stock_card_summary?site_id=" +
          site_id,
        null,
        null
      );
      this.stockCardSummary = summaryDetails;
      this.spinning = false;
      // this.componentKey++
    },
    async clearStockActivityFilter() {
      this.spinning = true;
      var currentSiteId = secureStorage.getItem("defaultSiteId");
      var summaryDetails = await HTTPRequest.getRequest(
        this.endPoint +
          "products/" +
          this.product.id +
          "/get_stock_card_summary?site_id=" +
          currentSiteId,
        null,
        null
      );
      this.stockCardSummary = summaryDetails;
      this.formSettings = {
        site_id: currentSiteId,
        document_date: [
          moment(new Date()).subtract("30", "days"),
          moment(new Date()),
        ],
      };
      this.stockCardDocuments = await HTTPRequest.getRequest(
        this.endPoint +
          "products/" +
          this.product.id +
          "/get_documents_for_stock_card?site_id=" +
          currentSiteId +
          "&start_date=" +
          this.formSettings.document_date[0].format("YYYY-MM-DD") +
          "&end_date=" +
          this.formSettings.document_date[1].format("YYYY-MM-DD"),
        null,
        null
      );
      // console.log(stockCardDocuments)
      this.componentKey++;
      this.data = this.stockCardDocuments.document_list;
      this.spinning = false;
    },
    async filterHistory() {
      var site_id = this.site_id;
      var start_date = this.formSettings2.update_date[0].format("YYYY-MM-DD");
      var end_date = this.formSettings2.update_date[1].format("YYYY-MM-DD");
      var historyData;
      this.spinning = true;
      switch (this.historyType) {
        case "1":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_price_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          // this.scroll = {x: 200 * 8, y: 300}
          break;
        case "2":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_cost_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          // this.scroll = {x: 200 * 7, y: 300}
          break;
        case "3":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_commission_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData;
          // .data
          // this.historyColumns = comission_history_columns
          // this.scroll = {x: 200 * 5, y: 300}
          break;
      }
      this.spinning = false;
    },
    async clearFilterHistory() {
      var site_id = -1;
      this.site_id = site_id
      var start_date = moment(new Date())
        .subtract("30", "days")
        .format("YYYY-MM-DD");
      var end_date = moment(new Date()).format("YYYY-MM-DD");
      this.formSettings2 = {
        site_id: site_id,
        update_date: [
          moment(new Date()).subtract("30", "days"),
          moment(new Date()),
        ],
      };
      var historyData;
      this.spinning = true;
      switch (this.historyType) {
        case "1":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_price_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData.data;
          this.scroll = { x: 200 * 8, y: 300 };
          break;
        case "2":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_cost_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData.data;
          this.scroll = { x: 200 * 7, y: 300 };
          break;
        case "3":
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_commission_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              site_id +
              "&start_date=" +
              start_date +
              "&end_date=" +
              end_date,
            null,
            null
          );
          this.historyData = historyData.data;
          this.historyColumns = comission_history_columns;
          this.scroll = { x: 200 * 5, y: 300 };
          break;
      }
      this.spinning = false;
      this.formKey++;
    },
    showChildrenDrawer(type, option) {
      this.childrenDrawer = true;
      this.childrenDrawerType = type;
      if (type == "customize_list") {
        switch (this.activeTab) {
          case "2":
            this.customizeList = this.availableFields;
            if (this.checkedFields.length == 0)
              this.checkedFields = [
                "Post Date",
                "Document Date",
                "Reference No",
                "Origin Ref No",
                "Party",
                "Total In ",
                "Total Out",
                "Balance",
                "Cost",
                "Document Price",
                "Subtotal",
                "Remark",
              ];
            break;
          case "3":
            this.quantityBreakdownFilter = option;
            if (this.quantityBreakdownFilter == "regular") {
              if (this.checkedRegularQuantityBreakdown.length == 0) {
                this.checkedFields = [
                  "Site/Sublocation Name",
                  "On-Hand Qty",
                  "Incoming Qty",
                  "Outgoing Qty",
                  "PO",
                  "STR & STI",
                  "SLI",
                  "POS Sales (TSI)",
                  "POS Return (TSR)",
                ];
              } else {
                this.checkedFields = this.checkedRegularQuantityBreakdown;
              }
              this.customizeList = this.regularQuantityBreakdown;
            } else if (this.quantityBreakdownFilter == "packing") {
              if (this.checkedPackingQuantityBreakdown.length == 0) {
                this.checkedFields = [
                  "Site/Sublocation Name",
                  "On-Hand",
                  "Incoming",
                  "Outgoing",
                ];
              } else {
                this.checkedFields = this.checkedPackingQuantityBreakdown;
              }
              this.customizeList = this.packingQuantityBreakdown;
            }
            break;
          case "4":
            switch (this.historyType) {
              case "1":
                if (this.checkedFields.length == 0)
                  this.checkedFields = [
                    "Wholesale Price",
                    "Least Price",
                    "Special Price",
                  ];
                this.customizeList = this.availableFields3;
                break;
              case "2":
                if (this.checkedFields.length == 0)
                  this.checkedFields = ["Original Cost", "Ordering Cost"];
                this.customizeList = this.availableFields4;
                break;
              case "3":
                if (this.checkedFields.length == 0)
                  this.checkedFields = ["Supplier Commission"];
                this.customizeList = this.availableFields5;
                break;
            }
            break;
        }
      }
    },
    updateTableColumns() {
      var reference_array = this.customizeList;
      var array = this.checkedFields;
      array.sort(function (a, b) {
        return reference_array.indexOf(a) - reference_array.indexOf(b);
      });
      this.checkedFields = array;
      var updatedColumns = [];
      this.scroll = { x: 200 * array.length, y: 500 };
      switch (this.activeTab) {
        case "2":
          var stockCardCol = stockcard_columns.slice()
          for(var i = 0; i < stockCardCol.length; i++){
            var stockCardColCopy = stockCardCol[i]["title"];
            if(this.checkedFields.includes(stockCardColCopy)){
              updatedColumns.push(stockCardCol[i])
            } else if (this.checkedFields.includes("Qty")){
              var qty = {title: "Qty", dataIndex: "QUANTITY", key: "Qty", width: 100, align: "right"}
              updatedColumns.push(qty)
            }
          }
          this.stockcardColumns = updatedColumns;
          break;
        case "3":
          if (this.quantityBreakdownFilter == "regular") {
            this.checkedRegularQuantityBreakdown = this.checkedFields;
            var tabulator = this.$refs.regular.getInstance();
            var hideColumns = _.difference(
              this.regularQuantityBreakdown,
              this.checkedFields
            );
            hideColumns.includes("Site/Sublocation Name")
              ? tabulator.hideColumn("name")
              : tabulator.showColumn("name");
            hideColumns.includes("On-Hand Qty")
              ? tabulator.hideColumn("on_hand_qty")
              : tabulator.showColumn("on_hand_qty");
            hideColumns.includes("Incoming Qty")
              ? tabulator.hideColumn("incoming_qty")
              : tabulator.showColumn("incoming_qty");
            hideColumns.includes("Outgoing Qty")
              ? tabulator.hideColumn("outgoing_qty")
              : tabulator.showColumn("outgoing_qty");
            hideColumns.includes("PO")
              ? tabulator.hideColumn("incoming_po")
              : tabulator.showColumn("incoming_po");
            hideColumns.includes("STR & STI")
              ? tabulator.hideColumn("incoming_str_sti")
              : tabulator.showColumn("incoming_str_sti");
            hideColumns.includes("SO")
              ? tabulator.hideColumn("incoming_so")
              : tabulator.showColumn("incoming_so");
            hideColumns.includes("SLI")
              ? tabulator.hideColumn("incoming_sli")
              : tabulator.showColumn("incoming_sli");
            hideColumns.includes("POS Sales (TSI)")
              ? tabulator.hideColumn("pos_sales_quantity")
              : tabulator.showColumn("pos_sales_quantity");
            hideColumns.includes("POS Return (TSR)")
              ? tabulator.hideColumn("pos_returns_quantity")
              : tabulator.showColumn("pos_returns_quantity");
          } else if (this.quantityBreakdownFilter == "packing") {
            this.checkedPackingQuantityBreakdown = this.checkedFields;
            var tabulator = this.$refs.packing.getInstance();
            var hideColumns = _.difference(
              this.packingQuantityBreakdown,
              this.checkedFields
            );
            hideColumns.includes("Site/Sublocation Name")
              ? tabulator.hideColumn("name")
              : tabulator.showColumn("name");
            if (hideColumns.includes("On-Hand")) {
              tabulator.hideColumn("onhand_complete");
              tabulator.hideColumn("onhand_spare");
            } else {
              tabulator.showColumn("onhand_complete");
              tabulator.showColumn("onhand_spare");
            }
            if (hideColumns.includes("Incoming")) {
              tabulator.hideColumn("incoming_complete");
              tabulator.hideColumn("incoming_spare");
            } else {
              tabulator.showColumn("incoming_complete");
              tabulator.showColumn("incoming_spare");
            }
            if (hideColumns.includes("Outgoing")) {
              tabulator.hideColumn("outgoing_complete");
              tabulator.hideColumn("outgoing_spare");
            } else {
              tabulator.showColumn("outgoing_complete");
              tabulator.showColumn("outgoing_spare");
            }
          }

          break;
        case "4":
          switch (this.historyType) {
            case "1":
              var phc_copy = price_history_columns.slice();
              var new_columns = [];
              for (var i = 0; i < phc_copy.length; i++) {
                var phc_copy_title = phc_copy[i]["title"];
                if (this.availableFields3.includes(phc_copy_title)) {
                  if (this.checkedFields.includes(phc_copy_title)) {
                    new_columns.push(phc_copy[i]);
                  }
                } else {
                  new_columns.push(phc_copy[i]);
                }
              }
              break;
            case "2":
              var phc_copy = cost_history_columns.slice();
              var new_columns = [];
              for (var i = 0; i < phc_copy.length; i++) {
                var phc_copy_title = phc_copy[i]["title"];
                if (this.availableFields4.includes(phc_copy_title)) {
                  if (this.checkedFields.includes(phc_copy_title)) {
                    new_columns.push(phc_copy[i]);
                  }
                } else {
                  new_columns.push(phc_copy[i]);
                }
              }
              break;
            case "3":
              var phc_copy = comission_history_columns.slice();
              var new_columns = [];
              for (var i = 0; i < phc_copy.length; i++) {
                var phc_copy_title = phc_copy[i]["title"];
                if (this.availableFields5.includes(phc_copy_title)) {
                  if (this.checkedFields.includes(phc_copy_title)) {
                    new_columns.push(phc_copy[i]);
                  }
                } else {
                  new_columns.push(phc_copy[i]);
                }
              }
              break;
          }

          this.scroll = { x: new_columns.length * 200, y: 500 };
          this.checkedFields = this.checkedFields;
          this.historyColumns = new_columns;
          break;
      }

      // this.onClose()
      this.childrenDrawer = false;
      this.$notification["success"]({
        message: "Successful Operation",
        description: "Updated Fields",
      });
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) this.checkedFields.splice(indexValue, 1);
      } else {
        this.checkedFields.push(fieldName);
      }
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.customizeList.length) {
        this.checkedFields = [];
      } else {
        this.checkedFields = this.customizeList.slice();
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    updateHistoryFilter(filters) {
      this.formSettings2 = filters;
    },
    onClose() {
      this.visible = false;
    },
    onChildrenDrawerClose() {
      this.childrenDrawer = false;
    },
    updateSettings(formSettings) {
      this.formSettings = formSettings;
    },
    async tabChange(activeKey) {
      this.checkedFields = [];
      this.activeTab = activeKey;
      this.spinning = true;
      var jsonField;
      // alert(activeKey);
      switch (activeKey) {
        case "2":
          var currentSiteId = secureStorage.getItem("defaultSiteId");
          var summaryDetails = await HTTPRequest.getRequest(
            this.endPoint +
              "products/" +
              this.product.id +
              "/get_stock_card_summary?site_id=" +
              currentSiteId,
            null,
            null
          );
          this.stockCardSummary = summaryDetails;
          this.formSettings = {
            site_id: currentSiteId,
            document_date: [
              moment(new Date()).subtract("30", "days"),
              moment(new Date()),
            ],
            sort_name: 'post_date',
            sort_by: 'desc'
          };
          this.stockCardDocuments = await HTTPRequest.getRequest(
            this.endPoint +
              "products/" +
              this.product.id +
              "/get_documents_for_stock_card?site_id=" +
              currentSiteId +
              "&start_date=" +
              this.formSettings.document_date[0].format("YYYY-MM-DD") +
              "&end_date=" +
              this.formSettings.document_date[1].format("YYYY-MM-DD"),
            null,
            null
          );
          this.data = this.stockCardDocuments.document_list;

          // DYNAMIC FORMS
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/StockActivityFilter?field_name=profile_name",
            null,
            null
          );
          this.convertedJson = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });
          this.componentKey++;
          this.scroll = { x: 200 * 11, y: 300 };
          break;
        case "3":
          this.scroll = { x: 200 * 8, y: 300 };
          this.scroll2 = { x: 200 * 4, y: 300 };
          // get_qty_breakdown
          // var qtyBreakdown = await HTTPRequest.getRequest(
          //   this.endPoint + "products/" + this.product.id + "/get_qty_breakdown"
          // );
          //this.total_per_site_data = qtyBreakdown.total_per_site;
          //this.total_per_site_packing_data =
          //  qtyBreakdown.total_per_site_packing;
          this.componentKey++;
          // console.log(qtyBreakdown)
          //console.log(this.stockCardDocuments.document_list)
          // this.data = this.stockCardDocuments.document_list
          break;
        case "4":
          var currentSiteId = -1;
          this.formSettings2 = {
            site_id: currentSiteId,
            update_date: [
              moment(new Date()).subtract("30", "days"),
              moment(new Date()),
            ],
          };
          this.scroll = { x: 200 * 8, y: 300 };
          var historyData;
          historyData = await HTTPRequest.getRequest(
            this.endPoint +
              "product_price_histories?product_id=" +
              this.product.id +
              "&site_id=" +
              currentSiteId,
            null,
            null
          );
          this.historyData = historyData;
          jsonField = await HTTPRequest.getRequest(
            this.endPoint +
              "dynamic_forms/ProductHistoryFilter?field_name=profile_name",
            null,
            null
          );
          this.convertedJson2 = ObjGen.xJson(jsonField.template, {
            numSpaces: 2,
          });
          this.formKey++;
          break;
        case "5":
          this.scroll = { x: 200 * 8, y: 300 };
          this.scroll2 = { x: 200 * 4, y: 300 };
          var currentSiteId = secureStorage.getItem("defaultSiteId");
          var data = await HTTPRequest.getRequest(
            this.endPoint +
              "products/" +
              this.product.id +
              "/serial_movement?site_id=" +
              currentSiteId +
              "&start_date=" +
              this.searchDateFrom +
              "&end_date=" +
              this.searchDateTo,
            null,
            null
          );
          this.serial_movement_data = data.serial_movement_data;
          this.componentKey++;
          break;
        case "6":
          this.scroll = { x: 200 * 8, y: 300 };
          this.scroll2 = { x: 200 * 4, y: 300 };
          var document_types = await HTTPRequest.getRequest(
            this.endPoint + "document_types/get_valid_document_types",
            null
          );
          this.documentTypeOptions = document_types;
          var currentSiteId = secureStorage.getItem("defaultSiteId");
          if (this.documentTypeIdFilter > 0) {
            var data = await HTTPRequest.getRequest(
              this.endPoint +
                "products/" +
                this.product.id +
                "/serial_inventory?site_id=" +
                currentSiteId +
                "&document_type_id=" +
                this.documentTypeIdFilter + "&per_page=10&page=" + this.serialPagination.current,
              null,
              null
            );
            this.serial_inventory_data = data.serial_inventory_data;
          } else {
            var data = await HTTPRequest.getRequest(
              this.endPoint +
                "products/" +
                this.product.id +
                "/serial_inventory?site_id=" +
                currentSiteId + "&per_page=10&page=" + this.serialPagination.current,
              null,
              null
            );
            this.serial_inventory_data = data.serial_inventory_data;
          }
          var pager = { ...this.serialPagination }
          pager.total = data.total_count
          this.serialPagination = pager
          this.componentKey++;
          break;
      }
      this.spinning = false;
    },
    async refreshTable() {
      if (this.currentSite["id"] != this.formSettings.site_id) {
        var siteDetails = await HTTPRequest.getRequest(
          this.endPoint + "sites/" + this.formSettings.site_id,
          null,
          null
        );
        this.currentSite["id"] = siteDetails["id"];
        this.currentSite["name"] = siteDetails["name"];
      }
      this.componentKey++;
    },
    // async handleSelectSitesQuantityBreakdown(value){
    //   this.selectedSitesQB = value
    //   if(value.includes(-1)){
    //     this.selectedSitesQB = [-1]
    //   }else{
    //     this.selectedSitesQB = value
    //   }
    //   console.log(this.selectedSitesQB);
    // },
    async filterQuantityBreakdown(){
        let lastLocId = this.inputLocationQB[this.inputLocationQB.length - 1]
        // regular
        var tabulator = this.$refs.regular.getInstance();
        tabulator.destroy()
        this.total_per_site_options.ajaxURL = this.endPoint + "products/" + this.product.id + "/get_qty_breakdown?mode=regular&location_id=" + lastLocId
        tabulator.options.ajaxURL = this.total_per_site_options.ajaxURL    
        tabulator.options.ajaxResponse = this.total_per_site_options.ajaxResponse    
        tabulator._create()
        // packing

        var packingTabulator = this.$refs.packing.getInstance();
        packingTabulator.destroy()
        this.total_per_site_packing_options.ajaxURL = this.endPoint + "products/" + this.product.id + "/get_qty_breakdown?mode=packing&location_id=" + lastLocId
        packingTabulator.options.ajaxURL = this.total_per_site_packing_options.ajaxURL
        packingTabulator.options.ajaxResponse = this.total_per_site_packing_options.ajaxResponse
        packingTabulator._create()
    },
    handleSerialTableChange(serialPagination, filters, sorter) {
      var pager = { ...this.serialPagination };
      pager.current = serialPagination.current;
      pager.pageSize = 10;
      this.serialPagination = pager;
      this.tabChange("6");
    },
    download(history) {
      let model = ''
      if (history == 'combo_price'){
        model = 'product_combo_price_update_histories'
      } else if (history == 'combo_group') {
        model = 'product_combo_group_update_histories'
      } else if (history == 'combo_value') {
        model = 'product_combo_value_update_histories'
      } else if (history == 'product') {
        model = 'product_update_histories'
      }
      let product_id = this.$attrs.product
      let payload = {}
      let additional_parameters = ""
      let baseUrl = this.endPoint + `${model}/export?file_type=csv&product_id=${product_id}`
   
      axios({
        url: baseUrl + additional_parameters,
        method: 'GET',
        responseType: 'blob', // important
        headers: {
          Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${model}.csv`);
        document.body.appendChild(link);
        link.click();
        // this.onClose();
        // this.filterStatus = null
        this.$notification['success']({
          message: 'Download Successful',
          description: "You have successfully downloaded your product history."
        });
      });
    },
  },
};
</script>

<style scoped>
.tabulator .tabulator-col-title {
  text-align: center;
}

/* .ant-drawer-header{
 background-color: #172B4D;
} */
.ant-table-thead > tr > th[key="previous_retail_price"],
.ant-table-thead > tr > th[key="current_retail_price"],
.ant-table-thead > tr > th[key="previous_wholesale_price"],
.ant-table-thead > tr > th[key="current_wholesale_price"],
.ant-table-thead > tr > th[key="previous_least_price"],
.ant-table-thead > tr > th[key="current_least_price"],
.ant-table-thead > tr > th[key="previous_special_price"],
.ant-table-thead > tr > th[key="current_special_price"],
.ant-table-thead > tr > th[key="previous_original_cost"],
.ant-table-thead > tr > th[key="current_original_cost"],
.ant-table-thead > tr > th[key="previous_ordering_cost"],
.ant-table-thead > tr > th[key="current_ordering_cost"],
.ant-table-thead > tr > th[key="previous_landed_cost"],
.ant-table-thead > tr > th[key="current_landed_cost"],
.ant-table-thead > tr > th[key="previous_product_commission"],
.ant-table-thead > tr > th[key="current_product_commissione"],
.ant-table-thead > tr > th[key="previous_supplier_commission"],
.ant-table-thead > tr > th[key="previous_grade_level"],
.ant-table-thead > tr > th[key="current_grade_level"],
.ant-table-thead > tr > th[key="current_supplier_commission"] {
  background-color: #efefef;
}

.ant-drawer-title {
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.08em;
  color: #8898aa;
}

.image-div {
  width: 144px;
  height: 144px;
  display: inline-block;
  background: #ffffff;
  /* border: 1px solid #C4C4C4; */
  /* box-sizing: border-box; */
  /* border-radius: 8px; */
}

.ant-upload-list-picture-card .ant-upload-list-item {
  float: left;
  width: 144px;
  height: 144px;
  margin: 0 8px 8px 0;
}

.modal-body {
  /* background-color: #F7F7F7; */
  background-color: white;
  border-top: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0;
}
.modal-body {
  margin: 0;
  padding: 0;
  padding-left: 80px;
  padding-right: 100px;
}

.ant-steps-item-process .ant-steps-item-icon {
  background: #65cb8f;
  border: #65cb8f;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical)
  .ant-steps-item-description {
  white-space: nowrap;
  max-width: 100%;
}
.ant-steps-item-finish .ant-steps-item-icon {
  border-color: #afb5bc;
  background-color: #fff;
}
.ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
  background-color: #afb5bc;
}
.user-group-header {
  border-bottom: 1px solid #e0e0e0;
}

#module-link:hover {
  background-color: #bae7ff;
  padding: 2px;
  border-radius: 3px;
}
#module-link {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  text-decoration: none;
  padding-left: 2px;
}
.product-icons{
  margin-right: 7px;
  height: 15px;
  width: 15px;
}
</style>


